import { memo } from 'react';
import ProductCard from './ProductCard';
import ProductCardSkeleton from './ProductCardSkeleton';
import EmptyState from './EmptyState';

const ProductGrid = memo(function ProductGrid({ products, isLoading, error, emptyStateType = 'default', searchTerm, hasActiveFilters, onClearFilters }) {
  if (error) {
    return (
      <div role="alert" aria-live="assertive" className="text-center py-12">
        <p className="text-red-600">Error loading products. Please try again.</p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div role="status" aria-live="polite" aria-label="Loading products" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(8)].map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <EmptyState
        type={emptyStateType}
        searchTerm={searchTerm}
        hasActiveFilters={hasActiveFilters}
        onClearFilters={onClearFilters}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
});

export default ProductGrid;
